<template>
  <div>
    <vs-row v-if="scales && datasets && datasets.length > 0">
      <vs-col :vs-w="2">
        <assessment-history-scale
          :key="key"
          :max="10"
          :min="0"
          :scale-definition="scales[selectedDataset.name]"/>
      </vs-col>
      <vs-col :vs-w="10">
        <vs-row row wrap justify-center align-center>
          <vs-col :vs-w="12">
            <assessment-history-chart v-if="selectedDataset"
                                      :key="key"
                                      :dataset="selectedDataset"
                                      :scale-definition="scales[selectedDataset.name]"
                                      @clicked-point="onClickedPoint"/>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row v-if="scales && datasets && datasets.length > 1">
      <vs-col :vs-w="12" class="text-center">
        <vs-button
          v-for="dataset in datasets"
          :key="dataset.name"
          :class="{'selectable': datasets.length > 1, 'starling-darkgrey--text': selectedDataset.name !== dataset.name}"
          :color="dataset.color"
          :type="selectedDataset.name === dataset.name ? 'filled':'border'"
          class="ml-1 mr-1 mb-2"
          @click="(e) => select(dataset)">
          {{ dataset.label }}
        </vs-button>
      </vs-col>
    </vs-row>
    <!--      <vs-row row wrap justify-center v-if="selectedPoints.length > 0">-->
    <!--        <vs-col xs12 v-for="point in selectedPoints" :key="point.assessment.assessmentId">-->
    <!--          <assessment-notes-display :user-assessment="point.assessment" @updated="onUpdatedAssessment(point, $event)" :editable="false"/>-->
    <!--        </vs-col>-->
    <!--      </vs-row>-->
  </div>
</template>

<script>
import moment from 'moment/moment';
import AssessmentHistoryScale from '@/views/app/view_member/charts/assessment-history-scale';
import AssessmentNotesDisplay from '@/views/app/view_member/charts/assessment-notes-display';
import AssessmentHistoryChart from '@/views/app/view_member/charts/assessment-history-chart';
import {CORE_ASSESSMENT_NAMES} from '@/views/app/view_member/charts/core_assessments';


/* eslint-disable security/detect-object-injection */
export default {
  name: 'assessment-history-wrapper',
  components: {
    AssessmentHistoryScale,
    AssessmentHistoryChart,
    AssessmentNotesDisplay
  },
  props: {
    chartContent: {
      type: Array,
      required: true
    },
    scaleDefinitions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      key: 0,
      datasets: [],
      selectedDataset: null,
      selectedPoints: [],
      scales: null,
      loading: true
    };
  },
  mounted () {
    this.buildChartObject(this.chartContent);
  },
  methods: {
    buildChartObject (res) {
      this.loading = true;

      const sorted = res.sort((a, b) => new Date(a.completed) - new Date(b.completed));
      const holder = {};

      sorted.forEach(element => {
        const point = {};
        point.assessment = {...element};
        point.x = moment(element.completed).startOf('day').toDate();
        point.y = element.scores.INTRINSIC.value;

        if (CORE_ASSESSMENT_NAMES.includes(element.assessmentName)) {
          if (!holder[element.assessmentName]) {
            holder[element.assessmentName] = [];
          }
          holder[element.assessmentName].push(point);
        }
      });

      const scaleHolder = {};
      this.scaleDefinitions.forEach(scale => {
        scaleHolder[scale.assessmentName] = scale;
      });
      this.scales = scaleHolder;

      const datasets = [];
      Object.keys(holder)
        .forEach(assessmentName => {
          const assessmentConfig = this.$t(`assessments.${assessmentName}`);
          datasets.push({
            name: assessmentConfig.name,
            label: assessmentConfig.label,
            data: holder[assessmentName],
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: assessmentConfig.color,
            color: assessmentConfig.color,
            pointBackgroundColor: assessmentConfig.color,
            pointRadius: 3,
            pointHoverRadius: 6,
            lineTension: 0,
            cubicInterpolationMode: 'monotone',
            definition: assessmentConfig.definition
          });
        });
      this.select(datasets[0]);
      this.datasets = datasets;
      this.loading = false;
      this.key++;
    },
    select (dataset) {
      this.selectedPoints = [];
      this.selectedDataset = dataset;
      this.key++;
    },
    onUpdatedAssessment (point, userAssessment) {
      point.assessment = userAssessment;
    },
    onClickedPoint (context) {
      const point = context.dataset.data[context.dataIndex];
      const foundIndex = this.selectedPoints.findIndex(e => e.assessment.id === point.assessment.id);
      if (context.selected) {
        if (foundIndex <= 0) {
          this.selectedPoints.unshift(point);
        }
      } else if (foundIndex >= 0) {
        this.selectedPoints.splice(foundIndex, 1);
      }
    }
  }
};
</script>
